import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import shortid from "shortid";

const ImageOnly = ({ articleObj, param }) => {
    var content = articleObj;
    return (
        <>
            <div key={shortid.generate()} className={`${content.attributes.articleRendering}      ${content.attributes.class}`} data-type="ImageOnly"
                style={content.attributes.articlePadding ? { padding: `${content.attributes.articlePadding}` } : {}}	>
                <div className='card-design'>
                    {content.attributes.mainImageUrl ? <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} to={content.attributes.mainImageUrl}>  <img src={`${content.mainImage ? content.mainImage : ""}`} className='img-fluid' alt={content.attributes.altText} fetchpriority="high" /></Link>
                        : <img src={`${content.mainImage}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} fetchpriority="high" className='img-fluid' alt={content.attributes.altText} />}
                    {content.attributes.videoUrl ?
                        <iframe src={`${content.attributes.videoUrl}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}
                    {content.attributes.mainVideoUrl ?
                         <iframe src={`${content.attributes.mainVideoUrl}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}
                </div>
            </div>
        </>
    )
}

export default ImageOnly
